<template>
  <div
    class="position-relative preview-container"
    :class="{
      correct: correct && displayCorrect,
      wrong: selected && !correct && displayCorrect,
    }"
  >
    <HMFixedAspectRatioContainer>
      <img :src="img" class="rounded" :class="{ dimmed: !selected }" />
    </HMFixedAspectRatioContainer>
    <div class="check-box">
      <i
        v-if="selected && correct && displayCorrect"
        class="fas fa-check-circle c-light-green"
      ></i>
      <i
        v-if="selected && !correct && displayCorrect"
        class="fas fa-times-circle c-coral"
      ></i>
      <i
        v-if="selected && !displayCorrect"
        class="fas fa-check-circle c-brand-color"
      ></i>
      <i v-if="!selected" class="fal fa-circle c-medium-gray"></i>
    </div>
    <div class="label c-medium-gray my-2">
      <span :class="{ 'c-charcoal': selected || correct }">
        {{ label }}
      </span>
    </div>
    <div class="correct-tag" v-if="correct && !selected && displayCorrect">
      <span class="text-uppercase c-light-green smaller">
        {{ $t('QUIZZES.LABEL.CORRECT') }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'HMImageCheckBoxGroupPreview',
  props: {
    correct: {
      type: Boolean,
      default: null,
    },
    displayCorrect: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Boolean,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    img: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.preview-container {
  padding: 0.5rem;
  width: 170px;
  height: auto;
  border-radius: $border-radius;

  &.correct {
    background-color: lighten($light-green, 30%);
  }

  &.wrong {
    background-color: lighten($coral, 30%);
  }
}

.check-box {
  position: absolute;
  left: 0.75rem;
  top: 0.75rem;
}

.dimmed {
  opacity: 0.5;
}
</style>
